import React from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import FormGroup from 'react-bootstrap/FormGroup';
import Col from 'react-bootstrap/Col';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import axios from 'axios';

import Link from '../../../Link';
import ImageUploadComponent from '../../../../components/Common/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommonImageDisplay';
import Loader from '../../../Common/Loader/Loader';
import InputFieldComponent from '../../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../../Common/SelectFieldComponent/SelectFieldComponent';

import onSubmit from './submit';
import validate from './validate';
import messages from '../../../../locale/messages';
import { updateTempImages } from '../../../../actions/siteadmin/TempImages/updateTempImages';
import { formatURL } from '../../../../helpers/formatUrl';
import { formatLocale } from '../../../../helpers/formatLocale';
import { api, contentPageUploadDir, siteUrl } from '../../../../config';

import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../../Common/Assets/SVGIcon/CommonSvgRemainingIcon';

import bt from '../../../../components/commonStyle.css';
import s from './AddContentPageForm.css';


class AddContentPageForm extends React.Component {

	constructor(props) {
		super(props)
		if (typeof window !== 'undefined') {
			this.CustomEditor = require('../../../Common/Editor/CustomEditor');
		}
		this.state = {
			selectedLanguages: []
		}
	}


	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicContent } = nextProps;
		let filteredLanguages = dynamicContent?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	success = async (file, fromServer) => {
		const { change, updateTempImages } = this.props;
		await change('pageBanner', fromServer && fromServer.fileName);
		await updateTempImages('ContentPage', 'pageBanner', fromServer && fromServer.fileName);
	}

	handlePageTitle = (value) => {
		const { change } = this.props;
		if (value) change('pageUrl', formatURL(value));
		else change('pageUrl', '');
	}

	renderQuill = ({ input, meta: { touched, error }, className }) => {
		const { Editor } = this.CustomEditor;
		const { formatMessage } = this.props.intl;

		return (
			<div>
				<Editor {...input} />
				{touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
			</div>
		);
	}


	async imageHandler() {
		const input = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/*');
		input.click();
		input.onchange = async () => {
			const file = input.files[0];
			const formData = new FormData();

			formData.append('image', file);

			// Save current cursor state
			const range = this.quill.getSelection(true);

			// Move cursor to right side of image (easier to continue typing)
			this.quill.setSelection(range.index + 1);

			// Get the filePath from Uploaded URL
			const response = await axios.post('/file-upload-cms', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			// Get Response from the String
			const data = await response?.data;
			let filePath = data.filePath;

			// Remove placeholder image
			this.quill.deleteText(range.index, 1);
			filePath = "/" + filePath;

			// Insert uploaded image
			const { ops } = this.quill.insertEmbed(range.index, 'image', filePath);

		};
	}

	renderFormControlSelect = ({ input, meta: { touched, error }, className, children, label }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={bt.space5}>
				{label && <label className={bt.commonLabelText} >{label}</label>}
				<FormControl as="select" {...input} className={className}>
					{children}
				</FormControl>
				{touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
			</div>
		)
	}

	renderFieldArray = ({ fields, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { languageList } = this.props;
		const { selectedLanguages } = this.state;
		!fields.length && fields.push({})

		return (
			<div className={bt.languageBox}>
				{fields && fields.map((item, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
					const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }];
					const languageOptionsFormatted = availableLanguages.map((locale) => {
						return {
							value: locale,
							label: formatLocale(locale)
						};
					});
					languagesOption.push(...languageOptionsFormatted);

					return (
						<div key={index}>
							<div className='oneColumnGrid'>
								<div className='twoColumnGrid'>
									<Field
										name={`${item}.language`}
										component={SelectFieldComponent}
										label={formatMessage(messages.language)}
										inputClass={bt.formControlSelect}
										options={languagesOption}
									/>
								</div>
								<div className='quillBox'>
									<label className={bt.commonLabelText} ><FormattedMessage {...messages.content} /></label>
									<Field
										name={`${item}.content`}
										type="text"
										component={this.renderQuill}
										autoComplete={false} />
								</div>
							</div>
							<div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })}>
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button onClick={() => fields.length <= languageList?.length - 1 && fields.push({})} className={cx(bt.languageBtn)}>
										<AddContentPlusIcon />
										<span>{formatMessage(messages.addLanguage)}</span>
									</Button>
								}
								{fieldLength > 0 && <div>
									<Button onClick={() => fields.remove(index)} className={cx(bt.languageBtn, bt.languageDeleteBtn)}>
										<DeleteContentPlusIcon />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})}
			</div >
		)
	}

	render() {
		const { handleSubmit, pageBanner, intl: { formatMessage }, addContentLoader, loading, submitting } = this.props;
		if (typeof window !== 'undefined') {
			return (
				<Form className={s.fullWidth} onSubmit={handleSubmit(onSubmit)}>
					<div className={cx(s.singleCard, bt.space4)}>
						<div className={cx(s.profileImgSection)}>
							<label className={bt.commonLabelText} ><FormattedMessage {...messages.pageImageBanner} /></label>
							<CommonImageDisplay loader={addContentLoader} imageSrc={pageBanner ? api.apiEndpoint + contentPageUploadDir + pageBanner : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadContentPageBannerImage'
								}}
								success={this.success}
								loaderName={'addContentLoader'}
							/>
						</div>
					</div>

					<div className='twoColumnGrid'>
						<Field
							name="metaTitle"
							type="text"
							placeholder={formatMessage(messages.metaTitle)}
							component={InputFieldComponent}
							label={formatMessage(messages.metaTitle)}
							inputClass={bt.formControlInput}
						/>
						<Field
							name="pageTitle"
							type="text"
							component={InputFieldComponent}
							label={formatMessage(messages.pageTitle)}
							placeholder={formatMessage(messages.pageTitle)}
							onChange={this.handlePageTitle}
							inputClass={bt.formControlInput}
						/>

						<Field
							name="metaDescription"
							type="text"
							placeholder={formatMessage(messages.metaDescriptionText)}
							component={InputFieldComponent}
							componentClass="textarea"
							label={formatMessage(messages.metaDescriptionText)}
							inputClass={bt.formTextArea}
						/>

						<Field
							name="pageUrl"
							type="text"
							component={InputFieldComponent}
							label={formatMessage(messages.pageUrl)}
							placeholder={formatMessage(messages.pageUrl)}
							isAddon
							prefixLabel={siteUrl}
							formGroupClass="addonMobileWrapper"
						/>
					</div>
					<div className={bt.sectionDividerBorder} />
					<FieldArray
						name='content'
						rerenderOnEveryChange={true}
						component={this.renderFieldArray} />


					<div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider)}>
						<Form.Group className={s.formGroup}>
							<div className='doubleBtnFlexEnd'>
								<Link to={'/siteadmin/contentpage/manage'} className={bt.btnSecondary} ><FormattedMessage {...messages.goBack} /></Link>
								<Loader
									type={"button"}
									label={formatMessage(messages.submitButton)}
									show={loading}
									buttonType={'submit'}
									className={cx(bt.btnPrimary, 'loaderButtonFlex')}
									disabled={submitting || loading}
								/>
							</div>
						</Form.Group>
					</div>
				</Form>
			);
		}
		else return <div></div>;
	}
}

AddContentPageForm = reduxForm({
	form: 'ContentPageForm',
	validate,
	onSubmit,
})(AddContentPageForm);

const contentPageFormSelector = formValueSelector('ContentPageForm');
const mapState = (state) => ({
	pageTitle: contentPageFormSelector(state, 'pageTitle'),
	pageBanner: contentPageFormSelector(state, 'pageBanner'),
	addContentLoader: state?.loader?.addContentLoader,
	languageList: state?.runtime?.availableLocales,
	dynamicContent: contentPageFormSelector(state, 'content'),
	loading: state.loader.ContentPageForm,
});

const mapDispatch = {
	change,
	updateTempImages
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AddContentPageForm)));